import { get } from 'lodash';

const styles = ({ color }) => ({
  container: {
    borderColor: get(color, 'borderColor'),
    borderWidth: 1,
    borderStyle: 'dashed',
    height: 40,
    margin: '0 auto',
    width: '100%',
  },
  containerWrapper: {
    marginLeft: -36,
    marginRight: -20,
  },
  innerText: {
    color: get(color, 'borderColor'),
    lineHeight: '40px',
    textAlign: 'center',
  },
  selectedContainer: {
    borderColor: get(color, 'link'),
  },
});

export default styles;
